/*! Lazy Image */
class LazyImage extends HTMLImageElement {
  constructor() {
    super();

    this.wrapper = this.closest('.media-wrapper');
    if (this.wrapper === null) return;

    // both watchers are only needed until the image has loaded (handleLazy is a no-op afterwards)
    this.onResize = this.handleLazy.bind(this);
    addEventListener('resize', this.onResize, true);
    this.observer = new MutationObserver((changes) => {
      if (changes.some((change) => change.attributeName.includes('src'))) this.handleLazy();
    });
    this.observer.observe(this, {attributes : true});

    this.handleLazy();
  }

  handleLazy () {
    const mql = window.matchMedia('(min-width: 750px)');
    if (mql.matches && this.classList.contains('medium-hide')) return;
    if (!mql.matches && this.classList.contains('small-hide')) return;
    if (this.complete || this.classList.contains('loaded') || this.waitingForLoad) return;

    this.waitingForLoad = true;
    this.wrapper.classList.add('loading');
    this.addEventListener('load', () => {
      this.waitingForLoad = false;
      const loaded = () => {
        this.classList.add('loaded');
        this.wrapper.classList.remove('loading');
        removeEventListener('resize', this.onResize, true);
        this.observer.disconnect();
      };

      window.requestIdleCallback ? window.requestIdleCallback(loaded, {timeout: 150}) : setTimeout(loaded);
    }, { once: true });
  }
}
window.customElements.define('lazy-image', LazyImage, { extends: 'img' });

class ProgPicture extends HTMLPictureElement {
  constructor() {
    super();

    this.abortController = new AbortController();
    this.addEventListener('touchmove', this.touchmove_handler, { signal: this.abortController.signal });
  }

  touchmove_handler(ev) {
    if (ev.scale > 1) {
      var hqImage = this.getAttribute('data-hq');
      this.querySelector('source').setAttribute('srcset', hqImage);
      this.abortController.abort();
    }
  }
}
window.customElements.define('prog-picture', ProgPicture, { extends: 'picture' });